window.dn = window.dn || {};

(function (dn, $, undefined)
{

    /**
     * Useful for capturing/removing all non letters and whitespace. Uses unicode from XRegExp 
     * to match all letters, not just English letters. See 'Letter' defined in:
     * https://github.com/slevithan/xregexp/blob/master/tools/output/categories.js
     * 
     * Defining this here in dn.js instead of _LayoutScriptsPartial.cshtml, because it's large
     * and I'd prefer to have it cached.
     * 
     * TODO: Once we've refactored the JS in _LayoutScriptsPartial.cshtml to be cacheable, we should 
     * define these unicode regex patterns one time, and re-use them in other patterns where we are
     * currently limping along with [A-Za-z], which is bad for i13n.
     */
    dn.constants.RegEx.NonLettersNumbersAndWhiteSpace = /([^\s0-9A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FEF\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7B9\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]+)/g;

    /**
     * Once the page loads, this uses dn.QueryStringToJson() to retrieve #hash params into this 
     * JS object. If a param appears multiple times, it's value will be an array instead of a single value.
     */
    dn.Hash = {};

    /** 
     * Once the page loads, this uses dn.QueryStringToJson() to retrieve querystring params into this 
     * JS object. If a param appears multiple times, it's value will be an array instead of a single value.
     */
    dn.QueryString = {};

    /** All the windows we're communicating with (typically iFrames). */
    dn.Windows = {};

    /** Customizing the relative date format of moment.js. Re: https://momentjs.com/docs/#/customization/relative-time/ */
    moment.locale
    (
        'en-short', 
        {
            parentLocale: 'en',
            relativeTime : {
                future: "in %s",
                past:   "%s",
                s: '%ds',
                ss: '%ds',
                m:  "1m",
                mm: "%dm",
                h:  "1h",
                hh: "%dh",
                d:  "1d",
                dd: "%dd",
                M:  "1mo",
                MM: "%dmo",
                y:  "1y",
                yy: "%dy"
            }
        }
    );

    // Configuration for ajax request limiting
    var ajaxWindowNumRequests = 0; // Counter for tracking requests
    var ajaxWindowStart = Date.now(); // Stores the timestamp of the first request in a potential series of requests

    // Function to log requests and check threshold
    function approveAjaxRequest(jqXHR, settings) 
    {
        var currentTime = Date.now();

        // Check if the current request is within the time window
        if ((currentTime - ajaxWindowStart) < dn.constants.AjaxWindowLengthMs) 
        {
            ajaxWindowNumRequests++;

            // Check if the threshold is exceeded
            if (ajaxWindowNumRequests > dn.constants.AjaxWindowMaxRequests) 
            {
                // Block further requests until the user reloads, by replacing the current `beforeSend` function 
                // with a function that always returns false.
                $.ajaxSetup
                ({
                    beforeSend: function(jqXHR, settings) 
                    {
                        showAjaxRequestLimitMessage();
                        return false; // Prevent all future requests from working
                    }
                });

                showAjaxRequestLimitMessage();

                jqXHR.abort();
                throw new Error('Too many ajax requests in a short period. Blocking further requests until page reload.');
            }
        } 
        else 
        {
            // Reset the counter and timestamp if the time window has passed
            ajaxWindowStart = currentTime;
            ajaxWindowNumRequests = 1;
        }

        return true;
    }

    /**
     * Called by our approveAjaxRequest function whenever there is an underlying onslaught of ajax requests
     * detected by our JS code. This function will display a modal to the user, informing them of the issue.
     */
    function showAjaxRequestLimitMessage() 
    {
        dn.ShowModal
        ({
            title: 'Browser Issue Detected', 
            body: 'We\'ve detected an underlying issue in the ' + dn.constants.CommunityName + ' web app.<br/><br/>Please reload the page to continue using ' + dn.constants.CommunityName + '. If this issue persists, please <a href="mailto:' + dn.constants.EmailSupport + '?subject=Browser%20Issue%20Detected">contact us</a>.',
            buttonText: "Reload App",
            onButtonClick: function(event, $element, options) 
            {
                window.location.reload();
            }
        });
    }

    /**
     * If we detect we're in an iframe, bust out of it. We mostly utilize this to
     * deal with scenarios where pages might be appearing in our own internal embed frames
     * when we don't want them to, such as when a file embed is being displayed to a user
     * that hasn't completed registration. We redirect them to registration to complete, but
     * that page may be then loading in an embed iframe. This can be called to bust out.
     * 
     * For higher security, set CSP headers related to frame-ancestors instead.
     */
    dn.BustOut = function()
    {
        // If we're being loaded in an iframe, such as a video embed that has
        // redirected an incomplete user to this page, then we need to bust out.
        if (window.top != window.self) { window.top.location.replace(self.location.href); }
    };

    /**
     * Convert all datetimeoffsets embedded in the DOM to local date display.
     */
    dn.ConvertTimestamps = function()
    {
        $(".datetime-utc").each(function (index, value) 
        {
            var dateTime = $(this).data("timestamp");
            var format = $(this).data("format");

            $(this).html
            (
                dn.FormatDateHtml
                (
                    moment.unix(dateTime).locale($(this).data("locale") || 'en'), 
                    $(this).data("title-prefix"),
                    $(this).data("title-suffix"),
                    format
                )
            )
            .removeClass("datetime-utc");

            if (!dn.IsTouchDevice)
            {
                // Only turn timestamps into tooltips if we're not on a touch device
                // We do this primarily so that the tooltip won't interfere in mobile
                // users copying timestamp anchor links.
                $(this).children().tooltip
                (
                    {
                        sanitize: false,
                        sanitizeFn: function (content) {return content;}
                    }
                );
            }
        });
    };

    /**
     * A fallback copy method if the dn.Copy() modern way fails.
     */
    function copyFallback(text, callback) 
    {
        var tempInput = document.createElement("input");
        tempInput.style = "position: absolute; left: -1000px; top: -1000px";
        tempInput.value = text;
        document.body.appendChild(tempInput);
        tempInput.select();
        document.execCommand("copy");
        document.body.removeChild(tempInput);

        if (callback)
        {
            callback(true);
        }
    }

    /**
     * Copy text to the clipboard. This method uses the modern navigator.clipboard API
     * if available, and falls back to a legacy method if not. If a callback is provided,
     * it will be called after the copy operation is completed, with true for success or
     * false for failure.
     */
    dn.Copy = function(text, callback)
    {
        if (navigator.clipboard && window.isSecureContext) 
        {
            navigator.clipboard.writeText(text)
            .then(function() 
            {
                if (callback) callback(true);
            })
            .catch(function(err) 
            {
                console.error("Clipboard write failed, falling back", err);
                copyFallback(text, callback);
            });
        } 
        else 
        {
            // Fallback for older browsers
            copyFallback(text, callback);
        }
    };

    /**
     * Debounce a function, i.e. only execute the function if it stops being called
     * after the given time period (in milliseconds). 
     * 
     * Source: https://github.com/component/debounce
     * 
     * @param {function} func The function to debounce.
     * @param {int} wait - Milliseconds must elapse before the function is executed.
     * @param {boolean} [immediate] - Specify true to cause debounce to trigger the function on the leading edge, i.e. for situations where you want to prevent double-clicks.
     */
    dn.Debounce = function(func, wait, immediate)
    {
        var timeout, args, context, timestamp, result;
        if (null == wait) wait = 100;

        function later() 
        {
            var last = Date.now() - timestamp;

            if (last < wait && last >= 0) 
            {
                timeout = setTimeout(later, wait - last);
            }
            else
            {
                timeout = null;

                if (!immediate)
                {
                    result = func.apply(context, args);
                    context = args = null;
                }
            }
        };

        var debounced = function()
        {
            context = this;
            args = arguments;
            timestamp = Date.now();
            var callNow = immediate && !timeout;

            if (!timeout) timeout = setTimeout(later, wait);
            if (callNow) 
            {
                result = func.apply(context, args);
                context = args = null;
            }

            return result;
        };

        debounced.clear = function() 
        {
            if (timeout) 
            {
                clearTimeout(timeout);
                timeout = null;
            }
        };

        debounced.flush = function()
        {
            if (timeout) 
            {
                result = func.apply(context, args);
                context = args = null;

                clearTimeout(timeout);
                timeout = null;
            }
        };

        return debounced;
    };

    /**
     * Similar to our ToString() C# extension to decimal which formats a decimal as a
     * string, only including the decimal point if needed. In either case the string will 
     * include the thousands separator, if needed. You specify the number of decimals to use, 
     * if they're needed.
     * 
     * WARNING: Above the value 999,999,999,999,999.9, this starts to return formatted integers
     * with no decimal places (rounded to the nearest integer). 
     * 
     * @param (decimal) num - The number to be formatted as a string.
     * @param (int) decimals - The number of decimals to use, if needed.
     */
    dn.DecimalToString = function(num, decimals) 
    {
        var decNum = parseFloat(num);
        var intNum = parseInt(num);

        if (decNum == intNum)
        {
            // nothing after the decimal point
            return intNum.toLocaleString('en');
        }
        else
        {
            // some fractional value
            return decNum.toLocaleString
            (
                'en', 
                {
                    minimumFractionDigits: decimals, 
                    maximumFractionDigits: decimals
                }
            );
        }
    };

    /** 
	 * Pass in the JSON received during an API request fail(), and this will return a
	 * user-friendly error message. 
     */
	dn.FormatApiError = function(json, jointext) 
    {
        if (json)
        {
            if (json.Message)
            {
                // API wants to return a blanket error
                return json.Message;
            }
            else
            {
                // our default Model errors 
                return $.map(json, function(i) { return i }).join(jointext ? jointext : ' ');
            }
        }

        return "There was an unexpected error.";
    };

    /**
     * Given a moment, and optional prefix/suffix for the title, this method returns the HTML for a span
     * that contains the relative timestamp as the primary text, and the title/tooltip of the absolute
     * timestamp, in the user's local timezone.
     * 
     * If you want non-relative timestamp as the primary text, pass in a format string (e.g. "MMM Do YYYY").
     * 
     * @param {object} moment - A momentjs object representing the timestamp to be formatted.
     * @param {string} titlePrefix - Anything you want added to the title/tooltip prior to the absolute timestamp.
     * @param {string} titleSuffix - Anything you want added to the title/tooltip after the absolute timestamp.
     * @param {string} format - (Optional) If given, we'll format using the given format (e.g. "MMM Do YYYY"), rather than using moment.fromNow() to generate a relative timestamp.)
     */
    dn.FormatDateHtml = function (moment, titlePrefix, titleSuffix, format) 
    {
        return '<span class="formatted-timestamp" data-toggle="tooltip" data-html="true" title="' + (titlePrefix || '') + moment.format("llll") + (titleSuffix || '') + '">' + (format ? moment.format(format) : moment.fromNow()) + '</span>'
    };

    /**
     * Return a random integer from 0 to one less than max.
     * 
     * @param {int} max - The (exclusive) max boundary for the random number.
     */
    dn.GetRandomInt = function(max) 
    {
        return Math.floor(Math.random() * Math.floor(max));
    };

     /**
     * Generic function to grab the html for generating the mute icon overlay for an image
     * 
     * @param {selector}      targetProfileImageSelector target to the image to overlay the icon over
     */
    dn.GetMuteBellIconDiv = function()
    {
        return "<div class=\"mute-icon-overlay\"></div>";
    };

    /**
     * Convert a URL and optional key into a redirect URL that will redirect to the given URL,
     * and track the click on our end for analytics.
     */
    dn.GetRedirectUrl = function(url, key) 
    {
        return '/redirect?url=' + encodeURIComponent(url) + (key ? '&key=' + encodeURIComponent(key) : '');
    };

    /** 
	 * Top-level error handler. Set up in _LayoutScriptsPartial to handle all ajax errors.
     *
     * IMPORTANT: if you handle something here, it also needs to be added to dn.IsErrorHandledAutomatically
     * to avoid custom handlers handling the error twice (e.g. if the page wants to show it's own error, it should
     * only do it if !dn.IsErrorHandledAutomatically())
     */
    dn.HandleAjaxError = function (event, xhr, ajaxSettings, thrownError) 
    {
        var errorMessage = (thrownError || xhr.statusText);

        // don't report errors for 400 Bad Request (in most cases these are model binding errors)
        if (xhr.status === 400 || errorMessage === "abort") 
        {
            return;
        }

        // they're logged out, redirect to login with current url in the returnurl param
        if (xhr.status === 401)
        {
            var returnurl = encodeURIComponent(window.location.href.replace(window.location.origin, "")); // use local url
            window.top.location.href = "/account/login?returnurl=" + returnurl;
            return;
        }

        // Forbidden. Check for a code to see why they're forbidden and take appropriate action
        if (xhr.status == 403) 
        {
            if (xhr.responseJSON.Code)
            {
                switch (dn.constants.ApiResponseStatusCode[xhr.responseJSON.Code]) 
                {
                    case "RegistrationIncomplete":
                        window.top.location.href = "/register";
                        break;

                    case "UpgradeRequired":
                        dn.PromptToUpgrade(xhr.responseJSON.Reason, (ajaxSettings.data ? JSON.parse(ajaxSettings.data) : {}));
                        break;

                    case "ConfirmTrial":
                        // The user tried to apply a code that requires the trial to be confirmed and/or a payment method to start the trial
                        dn.billing.ConfirmTrial(xhr.responseJSON);
                        break;

                    case "ReadOnly":
                        var title = "Your account is currently restricted";
                        var body = "<p class=\"lead\">You will not be able to post or interact with discussions until the restriction has been lifted by a member of our staff.</p><p>Account restrictions are an automatic process that can happen if our system detects unusual information on an account, or discrepancies with your actual location and the location provided on your account.</p><p>To request our staff lift the restriction, please <a href=\"/settings\">submit this form</a>, along with any account info changes that may warranted.</p>";
                        dn.ShowModal({title: title, body: body, buttonText: 'Request Account Review', onButtonClick: function(e) { window.top.location.href = "/settings"; }});
                        break;

                    case "AccountDeactivated":
                        window.top.location.href = "/settings"; // Settings page will convey their deactivated status
                        break;

                    case "AdministratorsOnly":
                    case "TypeManagersOnly":
                    default:
                        window.top.location.href = "/account/accessdenied";
                        break;
                }
            }
            else
            {
                console.error('Unknown Ajax 403 Error', xhr.responseJSON);
            }

            return;
        }

        // unexpected server error
        if (xhr.status >= 500 && xhr.status <= 599) 
        {
            var title = "Error";
            var body = dn.FormatApiError(xhr.responseJSON);
            dn.ShowModal({title: title, body: body});

            // don't call return; - allow fall-through for Sentry logging
        }

        // if we made it this far, it's a real error. 
        Sentry.captureMessage
        (
            thrownError || xhr.statusText, 
            {
                extra: 
                {
                    type: ajaxSettings.type,
                    url: ajaxSettings.url,
                    data: ajaxSettings.data,
                    status: xhr.status,
                    error: errorMessage,
                    response: (xhr['responseJSON'] ? xhr.responseJSON : (xhr['responseText'] ? (xhr['responseText'].length() > 100 ? xhr.responseText.substring(0, 100) : xhr.responseText) : ''))
                }
            }
        );
    };

    /**
     * Checks to see if a bitwise value is in the specified flag. i.e. is 2 (0010) in 6 (0110) => true
     * 
     * @param (int) value the passed value to check
     * @param (int) flag the flag to check against
     * @returns 
     */
    dn.HasFlag = function(value, flag) 
    {
        return (value & flag) === flag;
    };

    /**
     * Returns true if the given object has keys, i.e. like a dictionary
     * 
     * @param (object) A JS object to test.
     * @returns true if the object has keys, false otherwise (or if obj is null)
     */
    dn.HasKeys = function(obj) 
    {
        for (var key in obj) // if obj is null, JS will just skip down to the `return false`
        {
            if (obj.hasOwnProperty(key)) return true;
        }

        return false;
    };

    /**
     * Inserts the given $newItem into the given $listContainer, sorted by the given compareFunction.
     * Uses a binary search algorithm to find the correct insertion point, so it's critical that this
     * function is only used on already-sorted lists, or to build/maintain sorted lists of elements.
     */
    dn.InsertSorted = function($listContainer, $newItem, compareFunction)
    {
        var $existingItems = $listContainer.children();
        let start = 0;
        let end = $existingItems.length - 1;

        while (start <= end)
        {
            let mid = Math.floor((start + end) / 2);
            let compare = compareFunction($($existingItems[mid]), $newItem);
            
            if (compare < 0) 
            {
                end = mid - 1;
            } 
            else if (compare > 0) 
            {
                start = mid + 1;
            } 
            else 
            {
                start = mid;
                break;
            }
        }

        if (start >= $existingItems.length) 
        {
            // Append at the end if no smaller element is found
            $listContainer.append($newItem);
        } 
        else 
        {
            // Otherwise, insert before the identified child
            $newItem.insertBefore($existingItems[start]);
        }
    }

    /**
     * This interpolates a given `value` into a given object whenever the given
     * `pattern` is encountered in the value of the object's properties. These
     * properties could be at any level of the object (we traverse recursively).
     * 
     * WARNING: This function will modify the object directly by reference. If you
     * want your original object to be untouched, clone it first and then pass that in.
     * If you just want a simple "deep" clone suitable for a JSON object, do this:
     * 
     * dn.Interpolate(JSON.parse(JSON.stringify(myObj)), "{{input}}", value);
     * 
     * If a shallow copy works, using the ... spread operator might be faster:
     * 
     * dn.Interpolate({...obj}, "{{input}}", value);
     *      
     * If a full deep clone is needed, you probably need to look at Lodash.
     * 
     * For example, if the `pattern` was `{{variable}}` and this was the object:
     * 
     * {
     *     "Foo": "Bar",
     *     "Bizz": 
     *     {
     *         "Buzz": "{{variable}}"
     *     }
     * }
     * 
     * Then if you called this method and passed "Beep" as the `value`, you'd end up with:
     * 
     * {
     *     "Foo": "Bar",
     *     "Bizz": 
     *     {
     *         "Buzz": "Beep"
     *     }
     * }
     * 
     * @param (object)  obj - The object to traverse.
     * @param (obj)     patterns - Dictionary of patterns mapped to transform functions.
     * @param (var)     value - Whatever should replace the matched pattern.
     * 
     * @returns The object, with any matched properties interpolated.
     */
    dn.Interpolate = function(obj, patterns, value)
    {
        Object.keys
        (
            obj
        )
        .forEach
        (
            function(key, index)
            {
                if (obj[key] !== null && typeof obj[key] === "object")
                {
                    // recursively call this on sub-properties that are objects
                    dn.Interpolate(obj[key], patterns, value);
                }
                else if (patterns[obj[key]])
                {
                    obj[key] = patterns[obj[key]](value);
                }

                return;
            }
        );

        return obj;
    };

    /** 
	 * Useful for custom error handling. Use this to detect if our dn.HandleAjaxError function
     * is going to handle the error for you, or if you should handle it yourself.
     */
    dn.IsErrorHandledAutomatically = function (event, xhr, ajaxSettings, thrownError) 
    {
        // Bad Request - do not handle (these are usually model binding errors that need to be shown to the user inline)
        // if (xhr.status == 400) {
        //    return true;
        // }

        // logged out - redirect to login page
        if (xhr.status === 401) 
        {
            return true;
        }

        // forbidden - redirect based on Code
        if (xhr.status === 403) 
        {
            return true;
        }

        // unexpected server error
        if (xhr.status >= 500 && xhr.status <= 599) 
        {
            return true;
        }
    };

    /**
     * Returns true if the current device is a touch-capable device (uses finger input
     * rather than mouse/cursor). See: https://github.com/airbnb/is-touch-device/blob/master/src/index.js
     */
    dn.IsTouchDevice = 
    (
        !!(typeof window !== 'undefined' &&
            ('ontouchstart' in window ||
            (window.DocumentTouch &&
                typeof document !== 'undefined' &&
                document instanceof window.DocumentTouch))) ||
        !!(typeof window.navigator !== 'undefined' &&
            (window.navigator.maxTouchPoints || window.navigator.msMaxTouchPoints))
    );

    /**
     * Call this when you might need to use the rich text editor. It will check to see if it's
     * already loaded, and if not, it will load it (if the browser supports rich text editing, 
     * and if the user is logged in). 
     * 
     * For newer browsers, we'll check to see if they support importmaps, and if so, we'll load 
     * the newer version of CKEditor which uses ESM modules. If they don't support importmaps,
     * we'll load the older version of CKEditor which uses UMD modules. (The older version has 
     * bugs related to typing on Android, but those folks should be on newer browsers anyway.)
     * 
     * @param {func}    onComplete  - If given, we'll run this callback when the script is loaded
     *                                or if we're not going to load the script, run it immediately.
     */
    dn.LoadRichTextEditor = function(onComplete)
    {
        if (!window.BalloonEditor && dn.constants.UseRichTextEditor && dn.user.IsLoggedIn)
        {
            // Only write out the ckeditor script tag if we don't already
            // see `BalloonEditor`, only for browsers that can render it,
            // and only if the user is logged in (since they can't post otherwise anyway)
            console.debug("dn.LoadRichTextEditor", "Loading...");

            var script = document.createElement("script");

            if ('supports' in HTMLScriptElement && HTMLScriptElement.supports('importmap'))
            {
                // This is a newer browser, so we can load the newer ESM-based CKEditor.
                script.src = "/js/third-party/ckeditor.main.js?v=" + dn.constants.Version;
                script.type = "module";
            }
            else
            {
                // This is an older browser, so we'll load the older UMD-based CKEditor.
                script.src = "/js/third-party/ckeditor.js?v=" + dn.constants.Version;
            }
            
            script.onload = onComplete;
            document.body.appendChild(script);
        }
        else if (onComplete)
        {
            // Since the script loading wasn't needed, just run the code immediately
            onComplete();
        }
    };

    /**
     * This is where we store all the callbacks for screen rotation events.
     */
    var rotationCallbacks = 
    {
        list: {},
        idCounter: 0,
        initialized: false
    };

    /**
     * Internal handler for screen rotation events. This will call any registered
     * callbacks for the given rotation.
     */
    var rotationHandler = function (event) 
    {
        console.debug("ScreenOrientation.change", event.target);

        switch (event.target.type) 
        {
            // Portrait
            case 'portrait-primary':
            case 'portrait-secondary':
            {
                for (var id in rotationCallbacks.list) 
                {
                    console.debug('OnRotation', 'Portrait');
                    rotationCallbacks.list[id].onPortrait();
                }
                break;
            }

            // Landscape
            case 'landscape-primary':
            case 'landscape-secondary':
            {
                for (var id in rotationCallbacks.list) 
                {
                    console.debug('OnRotation', 'Landscape');
                    rotationCallbacks.list[id].onLandscape();
                }
                break;
            }

            // Unknown orientation
            default:
            {
                for (var id in rotationCallbacks.list) 
                {
                    console.debug('OnRotation', 'Unknown');
                    rotationCallbacks.list[id].onUnknown();
                }
                break;
            }
        }
    };

    /**
     * Do something when the screen is rotated. Specify onPortrait, onLandscape, and onUnknown
     * callbacks to be called when the screen is rotated to the given orientation.
     * 
     * Returns a unique identifier you can use to un-register your event handlers later,
     * via dn.RemoveRotationHandler(id);
     * 
     * @param (func) opt.onPortrait     - Called when the screen is rotated to portrait mode.
     * @param (func) opt.onLandscape    - Called when the screen is rotated to landscape mode.
     * @param (func) opt.onUnknown      - Called when the screen is rotated to an unknown orientation.
     */
    dn.HandleRotations = function (opt) 
    {
        if (!screen || !screen.orientation)
        {
            return null;
        }

        // Default empty functions if none provided
        var onPortrait = (opt.onPortrait || function () { });
        var onLandscape = (opt.onLandscape || function () { });
        var onUnknown = (opt.onUnknown || function () { });

        // Generate a unique identifier for this set of callbacks
        var id = 'rc' + rotationCallbacks.idCounter++;

        // Store the callbacks
        rotationCallbacks.list[id] = 
        {
            onPortrait: onPortrait,
            onLandscape: onLandscape,
            onUnknown: onUnknown
        };

        // Initialize event listener only once, the first time HandleRotations is called.
        if (!rotationCallbacks.initialized) 
        {
            screen.orientation.addEventListener("change", rotationHandler);
            rotationCallbacks.initialized = true;
        }

        return id;  // Return unique identifier
    };

    /**
     * Try to open a link in a new window (tab). If that fails due to access denied,
     * open the link in the same window. 
     * 
     * NOTE: This function can be overwritten in dn.constants.js.cshtml if we're
     * in a scenario where we don't want the browser to open links in a new window/tab.
     * This is why we only define it below if dn.OpenInNewWindows is not already defined.
     */
    dn.OpenInNewWindow = dn.OpenInNewWindow || function(url)
    {
        try 
        {
            window.open(url);
        }
        catch (e) 
        {
            window.window.location.href = url;
        }
    };

    /**
     * Similar to JavaScript's native `prompt()` command, this will use our custom modal 
     * dialog box, and provide the user with a text entry box that can be used to supply
     * some information. When the user submits the form by hitting enter after typing, or
     * by pressing the "submit" button we provide, we'll hit the `onSubmit` callback with
     * the value they provided. If the user closes the modal, we'll call onAbort() instead.
     * 
     * @param (string)  opt.title       - The title of the modal
     * @param (string)  opt.body        - The body before the input box (will be wrapped in <p>)
     * @param (string)  opt.suffix      - If provided, will be rendered after the input box.
     * @param (string)  opt.label       - The label to show above the input box, if any
     * @param (string)  opt.placeholder - The placeholder of the input box, if any
     * @param (string)  opt.type        - The type of the input box, defaulting to `text`
     * @param (string)  opt.class       - Any classes to be added to the input box, defaults to "col-12"
     * @param (string)  opt.buttonText  - Optional text for the primary button, defaults to "OK"
     * @param (func)    opt.onSubmit    - (Required) Once the user submits their answer, this is called with the value.
     * @param (func)    opt.onAbort     - (Optional) Called only when the user doesn't submit an answer.
     */
    dn.Prompt = function(opt)
    {
        opt.type = (opt.type || "text");
        opt.inputClass = (opt.inputClass || "col-12");
        opt.placeholder = (opt.placeholder || "");

        dn.ShowModal
        (
            {
                title: opt.title,
                body: '<p>' + opt.body + '</p>' +
                (opt.label ? '<label for="dn-prompt-input" class="dn-form-label mb-0">' + opt.label + '</label>' : '') +
                '<div class="input-group mb-3">\
                    <input type="' + opt.type + '" id="dn-prompt-input" value="" placeholder="' + opt.placeholder + '" class="form-control ' + opt.class + '" aria-label="' + opt.placeholder + '" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false"> \
                </div>' + 
                (opt.suffix ? '<p>' + opt.suffix + '</p>' : ''),
                buttonText: opt.buttonText || "OK",
                buttonClass: 'btn-success',
                closeButtonText: 'Cancel',
                preserveOpenModals: true,
                clickButtonOnEnter: true,
                // if they hit ENTER in the input box, the primary button is clicked
                onEnterSelector: 'input#dn-prompt-input', 
                onButtonClick: function (e, $modal) 
                {
                    $modal.addClass("dn-prompt-value-submitted");
                    opt.onSubmit($("#dn-prompt-input").val());
                },
                onClose: function (e, $modal)
                {
                    if (opt.onAbort && !$modal.hasClass("dn-prompt-value-submitted"))
                    {
                        opt.onAbort();
                    }
                },
                onOpen: function(e, $modal)
                {
                    $("#dn-prompt-input").focus();
                }
            }
        );
    };

    /**
     * Show the user a login dialog indicating they need to register or log in
     */
    dn.PromptToLogin = function (action) 
    {
        if (!action) 
        {
            action = "access this resource";
        }

        var title = "Please Login or Register"
        var body = "You must login or create an account to " + action + ".";

        var id = 'modal-' + dn.GetRandomInt(1000000);
        $("body").append($('<div class="modal" tabindex="-1" role="dialog" style="display: none" id="' + id + '">\
            <div class="modal-dialog" role="document">\
                <div class="modal-content">\
                    <div class="modal-header">\
                        <h5 class="modal-title"><b>' + title + '</b></h5>\
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">\
                        <span aria-hidden="true">&times;</span>\
                        </button>\
                    </div>\
                    <div class="modal-body">'

            + body

            + '<p id="closing-modal"></p>\
                    </div>\
                    <div class="modal-footer">'

            + '<button type="button" class="btn btn-primary" id="' + id + '-button-login">Sign In</button>'
            + '<button type="button" class="btn btn-success" id="' + id + '-button-register">Create Account</button>'

            + '</div>\
                </div>\
            </div>\
        </div>'));

        // stop any spinners and close any open modals before showing our new one
        dn.Spin(false);
        $('.modal').modal('hide');

        id = '#' + id;

        $(id + "-button-login").click
        (
            function () 
            {
                var encodedUrl = encodeURIComponent(window.location.href.replace(window.location.origin, "")); // use local url
                window.top.location.href = "/account/login?returnurl=" + encodedUrl;
            }
        );

        $(id + "-button-register").click
        (
            function () 
            {
                window.top.location.href = "/account/register";
            }
        );

        $(id).modal();
        $(id).modal('show');
    };

    /**
     * Show the user a prompt to subscribe to the given group before they can do the given action.
     */
    dn.PromptToSubscribe = function (topicIdOrKey, action, onSubscribe) 
    {
        dn.topic.Lookup
        (
            {
                topicIdOrKey: topicIdOrKey, 
                showAjaxSpinner: true, 
                onSuccess: function(topic) 
                {
                    if (!action) 
                    {
                        action = "access it";
                    }

                    var message = "You must subscribe to this group in order to " + action + ".";

                    var buttonClass = 'btn-subscribe-topic not-subscribed';
                    var buttonText = 'Subscribe';

                    if (dn.user.IsLoggedIn)
                    {
                        if (dn.user.TopicSubscriptionsPending.indexOf(topic.TopicId) > -1)
                        {
                            buttonClass = 'btn-subscribe-topic pending';
                            buttonText = 'Pending';
                            message += '<br/><br/>Your subscription is currently pending approval by the managers of the group.';
                        }
                        else if (dn.user.TopicSubscriptionsRejected.indexOf(topic.TopicId) > -1)
                        {
                            buttonClass = 'btn-subscribe-topic rejected';
                            buttonText = 'Unavailable';
                            message += '<br/><br/>Unfortunately your subscription request has been rejected by the managers of the group.';
                        }
                    }

                    dn.ShowModal
                    (
                        {
                            title: 'Group Subscription Required',
                            body: message,
                            doNotHideOnButtonClick: true,
                            buttonText: buttonText,
                            buttonClass: buttonClass,
                            buttonExtra: 'data-topic-id="' + topic.TopicId + '" data-topic-key="' + topic.TopicKey + '" data-topic-name="' + dn.text.QuoteAttribute(topic.Name) + '" data-topic-required-badges="' + JSON.stringify(topic.RequiredBadges) + '"',
                            onButtonClick: function(e) 
                            {
                                dn.topic.HandleSubscribeClick(e);
                            }, 
                            onClose: function(e)
                            {
                                if (onSubscribe && dn.user.IsLoggedIn && dn.user.TopicSubscriptions.indexOf(topic.TopicId) > -1)
                                {
                                    // they did subscribe
                                    onSubscribe(e);
                                }
                            }
                        }
                    );
                }, 
                onError: function() 
                {
                    console.error('Could not locate the given topic or group: ' + topicIdOrKey);
                }
            }
        );
    };

    /**
     * Show the user a prompt to upgrade their subscription level to unlock some capability.
     */
    dn.PromptToUpgrade = function (reason, requestData, buttonText, onButtonClick) 
    {
        var actionPrefix = "Your subscription doesn't allow ";
        var action = null;
        var callToAction = '<a href=\"/billing\">Upgrade your subscription</a> to enable this functionality.';

        switch (reason)
        {
            case "CanBookmark":
                action = "bookmarking messages";
                dn.TrackPaidFailure("Bookmark")
                break;

            case "CanMute":
                action = "muting members";
                dn.TrackPaidFailure("MuteUser")
                break;

            case "CanChat":
                actionPrefix = "";
                action = "Your membership offers <i>limited</i> private messaging.<br/><br/>Unless you upgrade to a Premium subscription to gain <i>unlimited</i> private messaging, you can only contact (or be contacted by) members with Premium subscriptions";
                callToAction = '<a href=\"/billing\">Start a premium subscription</a> to enable unlimited messaging.';
                dn.TrackPaidFailure("PrivateMessage")
                break;

            case "CanGroupChat":
                action = "posting to group chats";
                dn.TrackPaidFailure("GroupChat")
                break;

            case "CanManage":

                if (requestData.TopicId === 0)
                {
                    action = "creating user groups";
                    dn.TrackPaidFailure("GroupCreate")
                }
                else if (requestData.TopicId > 0)
                {
                    action = "editing user groups";
                }
                else
                {
                    action = "managing user groups";
                }

                break;

            case "CanPost":

                if (requestData.MessageKey)
                {
                    action = "editing messages";
                }
                else
                {
                    action = "starting new discussions";
                }

                break;

            case "CanRead":
                action = "reading discussions";
                break;

            case "CanReadReplies":  // not represented in our SubscriptionPlans table
                action = "reading replies";
                break;

            case "CanReply":
                action = "replying to messages";
                break;

            case "CanSearch":
                action = "searching messages";
                dn.TrackPaidFailure("Search")
                break;

            case "CanSetProfilePhoto":
                action = "setting a profile photo";
                break;

            case "CanTag":
                action = "tagging messages";
                break;

            case "CanUpload":
                action = "uploading files";
                break;

            case "CanVote":
                action = "voting on messages";
                break;

            default:
                action = "this action";
        }

        if (!buttonText)
        {
            buttonText = "View Subscription";
        }

        if (!onButtonClick)
        {
            onButtonClick = function (e) 
            {
                window.top.location.href = "/billing";
            };
        }

        dn.ShowModal
        (
            {
                title: "Upgrade Required",
                body: actionPrefix + action + ".<br/><br/>" + callToAction,
                buttonText: buttonText,
                buttonClass: 'btn-primary',
                onButtonClick: onButtonClick,
                preserveOpenModals: true
            }
        );
    };

    /**
     * Where we can handle inter-frame communication among our pages.
     */
    dn.ReceiveMessage = function(event) 
    {
        // TODO: Pull this regex from Constants somehow
        if (!/https?:\/\/(?:localhost|0\.0\.0\.0|(?:[^\.]+\.)?\bdiag\.net)\b(?::5000|\/|$)/.test(event.origin))
        {
            return; // ignore messages from unexpected domains
        }

        if (event.data.type === 'dn-iframe-init' && event.data.width > 0 && event.data.height > 0 && event.source && event.source.location)
        {
            // store the iframe info for later; we might be able
            // to size iframes more quickly the second time they're loaded
            dn.Windows[event.source.location.pathname] = event.data;
            dn.ResizeIframe(event.source.location.pathname, event.data);
        }
        else if (event.data.type === 'dn-fancybox-reset') 
        {
            // A request from our embed iframe to resize fancybox, if present
            var fancybox = $.fancybox.getInstance();

            if (fancybox)
            {
                fancybox.updateSlide(fancybox.current);
            }
        }
    };

    /**
     * Do something when the screen is rotated. Specify onPortrait, onLandscape, and onUnknown
     * callbacks to be called when the screen is rotated to the given orientation.
     * 
     * @param (string) id   - The unique identifier that was returned to you in the HandleRotations() call.
     */
    dn.RemoveRotationHandler = function (id) 
    {
        delete rotationCallbacks.list[id];
    };

    /** 
     * Resize the iFrame at the given path, if it's visible.
     * 
     * Currently only in use for Fancybox.
     */
    dn.ResizeIframe = function(pathname, opts)
    {
        var fancybox = $.fancybox.getInstance();

        if (fancybox)
        {
            // see if we're currently displaying this iframe
            if (pathname === fancybox.current.src)
            {
                // this iframe is visible now in the carousel, let's resize it
                if (opts.width <= opts.height)
                {
                    // fancybox only seems to need help with portrait/square iframes
                    fancybox.current.$content.height('100%');
                    var newHeight = fancybox.current.$content.height();
                    var newWidth = (newHeight * opts.aspectRatio);
                    fancybox.current.$iframe.width(newWidth);
                    fancybox.current.$iframe.height(newHeight);
                    fancybox.updateSlide(fancybox.current);
                }
            }
        }
    };

    /**
     * Internal function called when something has changed on the "Invite" form and
     * we want to see whether or not we should enable the Invite button, among other things.
     */
    var checkEnableShareButton = dn.Debounce
    (
        function()
        {
            var invitees = $('#dn-user-search-share').val();

            // Enable the Invite button if there is at least one invitee...
            // and they're not a group manager, or they are and it contains at
            // least one email address (non-member invite), or they have included groups.
            if (invitees && (!dn.user.IsGroupManager || invitees.indexOf("@") > -1 || $('#dn-group-search').val()))
            {
                $(".dn-group-invite-button").prop("disabled", false);
            }
            else
            {
                $(".dn-group-invite-button").prop("disabled", true);
            }
        },
        100,    // wait 100ms
        false   // execute after the first time period passes
    );

    /**
     * Share something with one or more people. Typically this would involve a member
     * sharing a message with someone else. Like dn.Invite(), if the person they are 
     * sharing with is not a member of DN, the message we send also acts like an invite.
     * If the person later joins and subscribes, we'll reward the sender with tokens.
     * 
     * Invite a user to join our community and/or one or more groups, or approve a subscription request, with an optional message.
     * 
     * @param {string}  opt.message         - If set, will be pre-filled into the box sent to the user being invited/approved.
     * @param {string}  opt.messageKey      - If we're sharing a message, this is the MessageKey of that message to be shared.
     * @param {string}  opt.author          - The author of the thing we're sharing, if any. Typically set on message shares.
     * @param {string}  opt.profilePhoto    - The profile photo of the author of the thing we're sharing, if any. Typically set on message shares.
     * @param {string}  opt.snippet         - The snippet of text that starts the message, to give the sharer some confirmation they're sharing the right thing.
     * @param {string}  opt.title           - The title of the thing to share. (If we're sharing a Message, this may be overwritten by the Message.Title when sending.)
     * @param {string}  opt.url             - The URL of the thing to share. (If we're sharing a Message, this may be overwritten by the Message.Url when sending, currently we only use this property for the native share sheet and Copy Link option)
     * @param {array}   opt.prefilledUsers  - A list of UserKeys and/or email addresses of users to invite/approve that will be preset in the form.
     * @param {array}   opt.suggestedUsers  - An array of initial user suggestions, if the user clicks into the user field, they can choose from these without typing.
     * @param {func}    opt.onSuccess       - If we're able to successfully invite (or queue invitation), we'll call this with the response.
     * @param {func}    opt.onError         - If we can't invite/approve the user for some reason, we'll call this with the jquery error info
     */
    dn.Share = function(opt)
    {
        if (!opt)
        {
            opt = {};
        }

        var What = "This";
        var what = "this";
        var thisWhat = "this";

        if (opt.messageKey)
        {
            What = "Message";
            what = "message";
            thisWhat = "this message";
        }

        var shareIcon = /Android/i.test(navigator.userAgent) ? 'fas fa-share-alt' : 'fas fa-arrow-up-from-bracket';

        dn.ShowModal
        (
            {
                title: 'Share ' + What,
                body: '<div class="mb-3 p-2 bg-light rounded">\
                    <div class="media bg-light">' +

                        (
                            opt.profilePhoto 
                            ? '<img class="mr-2 rounded dn-share-profile-photo" src="' + opt.profilePhoto + '" alt="">' 
                            : ''
                        ) +

                        '<div class="media-body overflow-hidden">\
                            <div class="text-truncate font-weight-bold" title="' + opt.title + '">' + opt.title + '</div>' + 
                            '<div>' + opt.author + '</div>\
                        </div>\
                    </div>\
                    <div class="mt-2"><i>' + opt.snippet + '</i></div>\
                </div>\
                <div><label for="dn-user-search-share" class="dn-form-label mb-0">Share With</label>\
                    <div class="input-group mb-2">\
                        <input name="nameNotSearch" type="text" id="dn-user-search-share" class="dn-user-search-share form-control col-12" aria-label="Names or email addresses of people to share this message with." placeholder="Names or email addresses" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" class="form-control dn-compose-users dn-autosuggest-field" data-role="tagsinput"> \
                    </div>\
                    <label for="share-comments" class="dn-form-label">Comments</label>\
                    <textarea class="form-control" id="share-comments" class="share-comments" rows="3" placeholder="(Optional) Let them know why you are sharing this.">' + (opt.message || '') + '</textarea>' + 

                    (
                        dn.constants.TokenInvitationAwardAmount > 0

                        // We are offering a reward in tokens for invitees that start a paid subscription.
                        ? '<div class="mt-2"><i class="fas fa-gift mr-1"></i><b>Reward:</b> We\'ll send you <b>' + dn.constants.TokenCurrencySymbolHtml + dn.DecimalToString(dn.constants.TokenInvitationAwardAmount, 2) + '</b> for each new member that starts a paid subscription from any share submitted directly via the form above. <a href="/help#tokens" target="' + dn.constants.LinkTargetNewWindow + '">Learn more about tokens.</a></div>'

                        // No awards at this time
                        : ''

                    ) +
                '</div>',
                hideCloseButton: true,
                bottomLeft: '<button type="button" id="dn-native-share-btn" class="btn dn-button mr-1" style="display:none;"><i class="' + shareIcon + ' mr-1"></i>Share via...</button><button type="button" id="dn-copy-link-btn" class="btn dn-button text-left" style="min-width: 8.5rem;"><i class="far fa-link-simple mr-1"></i>Copy Link</button>',
                buttonText: 'Share',
                buttonClass: 'btn-success dn-share-button',
                onButtonClick: function(event)
                {
                    dn.Spin(true);

                    $.postJSON
                    (
                        "/api/v1/share", 
                        {
                            Message: $('#share-comments').val(),
                            MessageKey: opt.messageKey,
                            Recipients: dn.text.Split($('#dn-user-search-share').val(), ","),
                            Title: opt.title,
                            Url: opt.url
                        }
                    )
                    .done
                    (
                        function (results) 
                        {
                            dn.Spin(false);

                            var sharingResults = '';

                            $.each
                            (
                                results.Results, 
                                function(index, result) 
                                {
                                    if (!result.Error)
                                    {
                                        sharingResults += '<li class="text-success"><i class="fas fa-check fa-fw"></i> ' + (result.User && result.User.UserKey ? result.User.Name : result.Identifier) + '</li>';
                                    }
                                    else
                                    {
                                        sharingResults += '<li class="text-danger"><i class="fas fa-times fa-fw"></i> ' + (result.User && result.User.UserKey ? result.User.Name : result.Identifier) + ': ' + result.Error + '</li>';
                                    }
                                }
                            );

                            dn.ShowModal
                            (
                                {
                                    title: 'Message Shared',
                                    body: 'We shared ' + thisWhat + ' with the following people:<br/><br/><ul class="list-unstyled">' + sharingResults + '</ul>'
                                }
                            );

                            if (opt.onSuccess)
                            {
                                opt.onSuccess(results);
                            }
                        }
                    )
                    .fail
                    (
                        function (xhr, textStatus, errorThrown) 
                        {
                            dn.Spin(false);

                            if (!dn.IsErrorHandledAutomatically(null, xhr, null, errorThrown)) 
                            {
                                // The initial request for the message details failed, tell the user
                                var body = dn.FormatApiError(xhr.responseJSON);
                                dn.ShowModal({ title: "Unexpected Error", body: body });
                            }

                            if (opt.onError)
                            {
                                opt.onError(xhr, textStatus, errorThrown);
                            }
                        }
                    );
                }
            }
        );

        // Use a brief timeout to attach handlers after the modal is rendered
        setTimeout(function()
        {
            var $nativeShareBtn = $('#dn-native-share-btn');

            if (opt.url.indexOf('?') > -1)
            {
                opt.url += '&shr=' + dn.user.UserKey;
            }
            else
            {
                opt.url += '?shr=' + dn.user.UserKey;
            }

            if (navigator.canShare && navigator.canShare({ url: opt.url }))
            {
                $nativeShareBtn.show();
                $nativeShareBtn.on('click', function(e)
                {
                    try 
                    {
                        navigator.share({ url: opt.url, title: opt.title || 'Share' });
                    } 
                    catch (error) 
                    {
                        if (!error.toString().includes('AbortError')) 
                        {
                            console.error('Error sharing:', error);
                        }
                    }
                });
            }

            $('#dn-copy-link-btn').on('click', function()
            {
                var $btn = $(this);
                var original = $(this).html();

                dn.Copy(opt.url, function(isSuccess)
                {
                    if (isSuccess)
                    {
                        $btn.html('<i class="far fa-link-simple mr-1"></i>Copied!').addClass('text-success');
                    }
                    else
                    {
                        $btn.html('<i class="fas fa-exclamation-triangle mr-1"></i>Copy Failed').addClass('text-danger');
                    }

                    setTimeout(function()
                    {
                        $btn.html(original).removeClass('text-success text-danger');
                    }, 2000);
                });
            });
        }, 0);

        // setup autosuggest for users
        dn.autosuggest.UserSetup
        (
            {
                selector: '#dn-user-search-share',
                prefilledUsers: opt.prefilledUsers,
                suggestExisting: true,
                suggestedUsers: opt.suggestedUsers,
                onChange: checkEnableShareButton
            }
        );

        checkEnableShareButton();
    };


    /**
     * Show the user a modal explaining more about the badges that are required for the given action.
     */
    dn.ShowBadgeModal = function(missingBadges, action, titleSuffix, finalNote)
    {
        if (missingBadges.length === 1)
        {
            console.debug(missingBadges);

            // Only one badge is missing, focus the modal body/title on that fact
            var badge = dn.constants.Badges[missingBadges[0]];

            console.debug(badge);

            dn.ShowModal
            (
                {
                    title: "<a href=\"" + (badge.UrlEarn || badge.Link) + "\"><span class=\"badge\" data-badgekey=\"" + badge.BadgeKey + "\" data-subscribe-target=\"topic\" style=\"" + badge.Styles + "\">" + badge.Name + "</span></a> Badge Required " + (titleSuffix || '') + " (It's Free)",
                    body: (action ? "<p><i>The " + badge.Name + " badge is required " + action + ".</i></p>" : "") + "<p>" + badge.Description + "</p>" + finalNote,
                    buttonText: badge.UrlEarn ? "Earn the " + badge.Name + " Badge (for Free)" : "Learn More",
                    onButtonClick: function(event, $element, options) 
                    {
                        options.onClose = null; // so that we don't trigger our onClose handler when the modal disappears
                        window.top.location.href = (badge.UrlEarn || badge.Link)
                    }
                }
            );
        }
        else
        {
            // (Likely rare) situation where multiple badges are required
            dn.ShowModal
            (
                {
                    title: "Missing Required Badges" + (titleSuffix || '') + " (Free)",
                    body: "<p>The following badge" + (missingBadges.length == 1 ? " is " : "s are ") + "required" + (action ? (" " + action) : "") + ":</p>" + 
                        missingBadges.map
                        (
                            function(badgeId) 
                            {
                                var badge = dn.constants.Badges[badgeId]; 
                                return "<h5><a href=\"" + badge.Link + "\"><span class=\"badge mb-2\" data-badgekey=\"" + badge.BadgeKey + "\" data-subscribe-target=\"topic\" style=\"" + badge.Styles + "\">" + badge.Name + "</span></a></h5>" +
                                    "<p>" + badge.Description + "</p>" + 
                                    (
                                        badge.UrlEarn 
                                        ? "<p><b><a href=\"" + badge.UrlEarn + "\">Earn the " + badge.Name + " Badge</a></b></p>"
                                        : "<p><b><a href=\"" + badge.Link + "\">Learn More About the " + badge.Name + " Badge</a></b></p>"
                                    );
                            }
                        )
                        .join("")
                }
            );
        }
    };

    /**
     * Shows a popover error message, red background and white text, pointing at the given element.
     * 
     * @param {element} $element     - The element to tie the error message to.
     * @param {string} error        - The error message to display. It can contain HTML.
     * @param {string} placement    - right/left/bottom/top placement of the element. defaults to right.
     */
    dn.ShowErrorForElement = function($element, error, placement)
    {
        $element.popover
        (
            {
                content: '<span aria-hidden="true" aria-label="Close" class="dn-popover-close">&times;</span>' + error, 
                trigger: 'manual', 
                container: 'body', 
                html: true,
                placement: (placement || 'right'), 
                // NOTE: Any changes to the `content` of this popover needs to comply with the Bootstrap
                // sanitizer settings, defined in the `whitelist` property below.
                whiteList: 
                {
                    // See: https://getbootstrap.com/docs/4.3/getting-started/javascript/#sanitizer
                    '*': ['class', 'dir', 'id', 'lang', 'role', 'type', 'aria-label', 'aria-hidden'],
                    a: ['target', 'href', 'title', 'rel'],
                    button: ['type'],
                    div: [],
                    i: [],
                    form: [],
                    input: ['name', 'type', 'placeholder', 'autocomplete', 'autocorrect', 'autocapitalize', 'spellcheck', 'data-role'],
                    label: ['for'],
                    p: [],
                    span: []
                },
                template: '<div class="popover bg-danger border border-danger" role="tooltip"><div class="arrow"></div><h3 class="popover-header text-white"></h3><div class="popover-body text-white"></div></div>'
            }
        )
        .popover('show')
        .on('hidden.bs.popover', function () { $element.popover('dispose')});

        // Make the close button work.
        var popoverId = $element.attr('aria-describedby');

        $('#' + popoverId).find('.dn-popover-close').click
        (
            function(e) 
            {
                $('#' + popoverId).popover('hide');
            }
        );
    };

    /**
     * View a file's details in full screen mode. If there are multiple files in a set, 
     * the user can scroll back and forth between them.
     * 
     * @param {element} element - Element they clicked on to initiate the gallery view.
     */
    dn.ShowFileInGallery = function($element, extramessage)
    {
        if (!dn.user.IsLoggedIn) 
        {
            dn.PromptToLogin('view attachments');
        }
        else 
        {
            // Get the index of this message's backing data in dn.stream.Vue.Messages
            var vueIndex = $element.closest('.message').data('vue-index');

            if (vueIndex && dn.stream.Vue.Messages[vueIndex].IsAnonymized)
            {
                // The user is logged in, but the message was anonymized, so they cannot view files from the message.
                // The only scenario where this should be able to happen is viewing a closed message that's anonymized.
                // So find out what the TopicId is of the closed group, and prompt them to subscribe to it if found.
                var closedGroupIndex = dn.stream.Vue.Messages[vueIndex].TopicTypes.findIndex
                (
                    function(element, index, array)
                    {
                        return (element == dn.constants.TopicType.ClosedGroup);
                    }
                );

                if (closedGroupIndex > -1 && dn.stream.Vue.Messages[vueIndex].Topics.length > closedGroupIndex)
                {
                    // They are trying to view attachments in a message posted to a closed/private group that they aren't subscribed to
                    dn.PromptToSubscribe(dn.stream.Vue.Messages[vueIndex].Topics[closedGroupIndex], 'view attachments', function(e) { dn.ShowFileInGallery($element, extramessage); });
                }
                else
                {
                    // This should never happen, but will show a generic error if so.
                    dn.ShowModal({ title: "Problem Viewing File", body: "<p>There was a problem viewing this file.</p>" + (extramessage || '') });
                }

                return;
            }

            var filetype = parseInt($element.data('filetype'));

            if ((filetype & dn.constants.FileTypes.AwaitingConversion) != 0) 
            {
                var file = ((filetype & dn.constants.FileTypes.Video) != 0) ? "Video" : (((filetype & dn.constants.FileTypes.Audio) != 0) ? "Audio" : "File");
                dn.ShowModal({ title: file + " Processing In Progress", body: "<p>We're currently processing the file, which may take a few minutes.</p>" + (extramessage || '') });
            }
            else
            {
                $.fancybox.open
                (
                    $('[data-fancybox-trigger="' + $element.data('fancybox-trigger') + '"]'), 
                    {
                        animationDuration: 200,
                        transitionEffect: "slide",
                        transitionDuration: 300,
                        iframe: 
                        {
                            preload: true
                        },
                        afterLoad: function(instance, current) 
                        {
                            if (dn.Windows[current.src])
                            {
                                dn.ResizeIframe(current.src, dn.Windows[current.src]);
                            }                            
                        }
                    }, 
                    $element.index()
                );
            }
        }
    };

    /**
     * Show a modal dialog with the given HTML title and body. Any visible spinner
     * will be hidden before showing the modal.
     * 
     * @param {object}      opt:
     * @param {string}      opt.title - Title for the modal (HTML OK). If empty, no header bar is shown.
     * @param {string}      opt.body - Body for the modal (HTML OK).
     * @param {string}      opt.classes - Any classes to add to the top level `div`.
     * @param {function}    opt.onClose - Callback function called when the modal closed or hidden. WARNING: This will be called whenever/however the modal is dismissed!
     * @param {function}    opt.onOpen - Callback function called when the modal is opened (with reference to the modal).
     * @param {string}      opt.buttonText - Text for the primary action button, otherwise we'll use "OK" if onPrimaryButtonClick is set to a callback.
     * @param {string}      opt.buttonClass - The button class to use, defaults to 'btn-primary' if none given. Other options: btn-success, btn-danger, etc.
     * @param {string}      opt.buttonExtra - Any extra text that should be put inside the <button> tag.
     * @param {string}      opt.headerCss - Any inline CSS you want to apply to the header area.
     * @param {string}      opt.bodyCss - Any inline CSS you want to apply to the body area.
     * @param {string}      opt.footerCss - Any inline CSS you want to apply to the bottom area.
     * @param {function}    opt.onButtonClick - Callback function called when the primary action button is clicked. If null, no primary action button will be 
     *                                          displayed. It will get (event, $element, options), where options are the options passed INTO ShowModal in the 
     *                                          first place. Here you could, e.g., null out options.onClose if you wanted to prevent that handler from running.
     * @param {bool}        opt.onEnterSelector - If true, we'll listen on the given jQuery selector(s) for the use of the ENTER key, and if heard, will click the primary button.
     * @param {bool}        opt.doNotHideOnButtonClick - Defaults to false. If true, we'll keep the modal open after the button is clicked.
     * @param {bool}        opt.hideCloseButton - If true, the secondary button is not shown.
     * @param {string}      opt.closeButtonText - The text of the close button, defaulting to "Close"
     * @param {string}      opt.closeButtonClass - The button class to use for the close button, defaults to 'btn-secondary' if none given. Other options: btn-success, btn-danger, etc.
     * @param {bool}        opt.preserveOpenModals - If true, we will temporarily hide, and then recover, any currently open modals.
     * @param {string}      opt.bottomLeft        - Any HTML to put at the bottom left of the modal.
     * @returns             The $modal object.
     */
    dn.ShowModal = function(opt)
    {
        var id = 'modal-' + dn.GetRandomInt(1000000);
        $("body").append($('<div class="modal ' + (opt.classes || "") + '" tabindex="-1" role="dialog" style="display: none" id="' + id + '">\
            <div class="modal-dialog" role="document">\
                <div class="modal-content">' +

                    (
                        opt.title 

                        ? '<div class="modal-header" style="' + (opt.headerCss || "") + '">\
                            <h5 class="modal-title"><b>' + opt.title + '</b></h5>\
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">\
                            <span aria-hidden="true">&times;</span>\
                            </button>\
                        </div>'

                        : ''
                    ) +

                    '<div class="modal-body" style="' + (opt.bodyCss || "") + '">'

                    + opt.body 

                    + '<p id="closing-modal"></p>\
                    </div>\
                    <div class="modal-footer" style="' + (opt.footerCss || "") + '">' +

                    (
                        opt.bottomLeft 
                            ? '<div class="mr-auto">' + opt.bottomLeft + '</div>'
                            : ''
                    ) +

                    (
                        opt.hideCloseButton 
                            ? ''
                            : '<button type="button" class="btn ' + (opt.closeButtonClass ? opt.closeButtonClass : 'btn-secondary') + '" data-dismiss="modal">' + (opt.closeButtonText || "Close") + '</button>'
                    ) + 

                    (opt.onButtonClick ? ('<button type="button" class="btn ' + (opt.buttonClass ? opt.buttonClass : 'btn-primary') + '" id="' + id + '-button" ' + opt.buttonExtra + '>' + (opt.buttonText ? opt.buttonText : 'OK') + '</button>') : '')

                    + '</div>\
                </div>\
            </div>\
        </div>'));

        // stop any spinners and close any open modals before showing our new one
        dn.Spin(false);

        // remember the modals that were already open before us, so we can show them when done. 
        var openModals = null;
        if (opt.preserveOpenModals)
        {
            openModals = $('.modal.show');
            openModals.modal('hide');
        }
        else
        {
            $('.modal').modal('hide');
        }

        id = '#' + id;

        if (opt.onButtonClick)
        {
            $(id + '-button').click(function(e) 
            {
                opt.onButtonClick(e, $(id), opt);
                if (!opt.doNotHideOnButtonClick)
                {
                    $(id).modal('hide');
                }
            });
        }

        $(id).on('hidden.bs.modal', function (e) 
        {
            if (openModals)
            {
                // re-show modals that were open when we first appeared
                openModals.modal('show'); 
            }

            if (opt.onClose)
            {
                opt.onClose(e, $(id));
            }

            setTimeout
            (
                function() 
                {
                    $(id).modal('dispose');
                    $(id).remove();
                }, 
                100
            );
        });

        if (opt.onOpen)
        {
            $(id).on
            (
                'shown.bs.modal', 
                function (e) 
                {
                    opt.onOpen(e, $(id));
                }
            );
        }

        if (opt.onEnterSelector)
        {
            // Setup our listener, if the user hits ENTER in the given elements, 
            // we will simulate a click on the primary button. 
            $(document).on
            (
                'keydown',  // case insensitive, sees all keys (compared to keypress, case sensitive and ignores CTRL/SHIFT/ALT)
                opt.onEnterSelector, 
                function(e) 
                {
                    if (e.which === 13) 
                    {
                        $(id + '-button').click();
                        return false;
                    }
                }
            );
        }

        $(id).modal();

        if (opt.onCreate)
        {
            opt.onCreate($(id));
        }

        $(id).modal('show');

        return $(id);
    };

    /**
     * Show a notification to the user. These appear in the upper/right side of the page, below the menu bar.
     * 
     * @param {object}      opt:
     * @param {string}      opt.title - Title for the notification (HTML OK).
     * @param {string}      opt.body - Body for the notification (HTML OK).
     * @param {string}      opt.className - Any classes to include in the top-level element, after "toast", e.g. "toast-success"
     * @param {bool}        opt.autohide - Whether or not we should autohide the notification, defaults to true.
     * @param {func}        opt.beforeDisplay - If set, execute this before the toast is displayed. We pass in the 
     *                      unique id selector for the newly created notification.
     * @param {func}        opt.onClick - Callback function called when the notification is clicked on anything but the close button
     * 
     * @returns {string}    The unique selector (id prefixed with #) for the newly created notification.
     */
    dn.ShowNotification = function(opt)
    {
        if (!opt.hasOwnProperty('autohide'))
        {
            opt.autohide = true;
        }

        var id = 'dn-toast-' + dn.GetRandomInt(1000000);
        $("body").append($('<div class="toast ' + opt.className + '" role="alert" aria-live="assertive" aria-atomic="true" data-delay="7000" data-autohide="' + opt.autohide + '" id="' + id + '">\
            <div class="toast-header">\
                <strong class="mr-auto">' + opt.title + '</strong>\
                <button type="button" class="ml-2 mb-1 close" data-dismiss="toast" aria-label="Close">\
                    <span aria-hidden="true">&times;</span>\
                </button>\
            </div>' +

            (opt.body ? ('<div class="toast-body">' + opt.body + '</div>') : '') + 

        '</div>'));

        id = '#' + id;

        if (opt.beforeDisplay)
        {
            opt.beforeDisplay(id);
        }

        $(id).toast();
        $(id).toast('show');

        if (opt.onClick)
        {
            $(id).click(function(e) 
            {
                opt.onClick(e, $(id));
            });
        }

        return id;
    };

    /** 
     * Display a spinner in the center of the screen, with a darkened background, to prevent users from doing anything. 
     */
    dn.Spin = function(spin, opts) 
    {
        if (opts === undefined) 
        {
            opts = 
            {
                lines: 13, // The number of lines to draw
                length: 20, // The length of each line
                width: 10, // The line thickness
                radius: 30, // The radius of the inner circle
                corners: 1, // Corner roundness (0..1)
                rotate: 0, // The rotation offset
                direction: 1, // 1: clockwise, -1: counterclockwise
                color: '#000', // #rgb or #rrggbb or array of colors
                speed: 1, // Rounds per second
                trail: 56, // Afterglow percentage
                shadow: false, // Whether to render a shadow
                hwaccel: false, // Whether to use hardware acceleration
                className: 'spinner', // The CSS class to assign to the spinner
                zIndex: 2e9, // The z-index (defaults to 2000000000)
                top: '50%', // Top position relative to parent
                left: '50%' // Left position relative to parent
            };
        }

        var data = $('body').data();

        if (data.spinner) 
        {
            data.spinner.stop();
            delete data.spinner;
            $("#spinner_modal").remove();
            return this;
        }

        if (spin) 
        {
            var spinElem = this;

            $('body').append('<div id="spinner_modal" style="background-color: rgba(0, 0, 0, 0.3); width:100%; height:100%; position:fixed; top:0; left:0; z-index:' + (opts.zIndex - 1) + '"/>');
            spinElem = $("#spinner_modal")[0];

            data.spinner = new Spinner
            (
                $.extend
                (
                    {
                        color: $('body').css('color')
                    }, 
                    opts
                )
            )
            .spin(spinElem);
        }
    };

    /**
     * Parses a querystring comprised of name=value pairs that are concatened with ampersands,
     * converts it into JSON, and returns it, e.g. {name: value}. If the same name is encountered
     * multiple times, it's value will be an array rather than a scalar, e.g. {name: [value1, value2]}.
     * 
     * If you don't pass in a querystring, we'll use the one present in the browser (e.g. window.location.search).
     * If the string begins with a ? or # it will be stripped before being parsed. So it's safe to pass in 
     * window.location.search or window.location.hash.
     * 
     * Based on StackOverflow answer: https://stackoverflow.com/a/47517503/650558
     */
    dn.QueryStringToJson = function(queryString) 
    {
        var json = {};

        if (!queryString)
        {
            // They didn't pass in a queryString, so use the window.location querystring or hash.
            queryString = window.location.search || window.location.hash;
        }

        if (!queryString)
        {
            // exit early if there's nothing to process
            return json;
        }

        var pairs = (/^[\?\#]/.test(queryString) ? queryString.substr(1) : queryString).split('&');

        for (var i = 0; i < pairs.length; i++) 
        {
            var pair = pairs[i].split('=');
            var key = decodeURIComponent(pair[0]);
            var val = decodeURIComponent(pair[1] || '');

            if (json[key])
            {
                // multiple values, need to deal with array
                if (Array.isArray(json[key]))
                {
                    // add to existing array
                    json[key].push(val);
                }
                else
                {
                    // turn this into an array
                    json[key] = [json[key], val];
                }
            }
            else
            {
                // regular string parameter
                json[key] = val;
            }

        }
        return json;
    };

    /**
     * Turns a JSON object generated by QueryStringToJson() back into a querystring. If prefix is
     * given, we will add that to the resulting string IFF the string isn't empty, so it's safe to
     * just throw this at the end of your URL. You probably want to use "?" or "#" for the prefix,
     * depending on whether you want to turn this into a ?querystring or #hash.
     */
    dn.QueryStringFromJson = function(json, prefix) 
    {
        if (!json)
        {
            return "";
        }

        var params = Object.keys(json);
        if (!params || params.length === 0)
        {
            return "";
        }

        // Good to go, let's start building our querystring
        var queryString = prefix;

        for (var i = 0; i < params.length; i++)
        {
            if (Array.isArray(json[params[i]]))
            {
                for (var j = 0; j < json[params[i]].length; j++)
                {
                    queryString += encodeURIComponent(params[i]) + "=" + encodeURIComponent(json[params[i]][j]) + "&";
                }
            }
            else if (json[params[i]] != null && json[params[i]] !== '') // NOTE: We want to use != here, not !==, because we want to catch undefined and null
            {
                queryString += encodeURIComponent(params[i]) + "=" + encodeURIComponent(json[params[i]]) + "&";
            }
        }

        return queryString.substring(0, (queryString.length - 1)); // substring removes trailing "&"
    };

    /**
     * Show a modal dialog explaining that the message has been downvoted below the community threshold.
     */
    dn.ShowDownvotedModal = function($element)
    {
        var authorUserKey = $element.data('userkey');
        var authorIsAdmin = $element.data('isadmin');
        var authorIsManager = $element.data('ismanager');

        var message = '';

        if (authorIsAdmin || authorIsManager)
        {
            // The author is a community admin or group manager
            message = 'Although the message in question has been cumulatively downvoted below the community threshold, it is not hidden from view because the message was authored by a community administrator or manager of a topic or user group to which the message was posted.';
        }
        else if (dn.user.IsLoggedIn && dn.user.UserKey === authorUserKey)
        {
            // The user is the author of the message
            message = 'The message in question has been cumulatively downvoted below the community threshold and may be hidden from message streams and search results for most users.<br/><br/>The message is visible to you because you are the author.<br/><br/>Please consider editing your message to address any issues members have mentioned or tagged. <a href="/help#asking-for-help">More about asking for help on ' + dn.constants.CommunityName + '</a>.';
        }
        else if (document.location.pathname.startsWith('/u/'))
        {
            // We are viewing a user's profile
            message = 'The message in question has been cumulatively downvoted below the community threshold and may be hidden from message streams and search results for most users.<br/><br/>The message is visible to you because you are viewing this message from the author\'s profile page.';
        }

        dn.ShowModal
        ({
            title: "Message Downvoted",
            body: message,
        });
    };

    /**
     * Track our completed registrations.
     */
    dn.TrackCompletedRegistration = function(plan, planValue, subscriptionId)
    {
        if (window["fbq"] !== undefined)
        {
            fbq
            (
                'track', 
                'CompleteRegistration', 
                {
                    value: planValue,
                    currency: 'USD',
                    content_name: plan,
                    status: 'complete',
                    is_eligible_for_annual_package: false
                }
            );
        }

        if (window["twq"] !== undefined)
        {
            twq
            (
                'track',
                'Purchase', 
                {
                    value: planValue,
                    currency: 'USD',
                    num_items: '1',
                    order_id: subscriptionId
                }
            );
        }

        if (window["gtag"] !== undefined)
        {
            gtag
            (
                'event', 
                'purchase', 
                {
                    event_category: 'ecommerce',
                    event_label: plan,
                    content_id: plan,
                    content_type: "subscription",
                    value: Math.round(planValue), // google wants integers for some reason
                    currency: 'USD',
                    transaction_id: subscriptionId
                }
            );
        }
    };

    dn.TrackPaidFailure = function(event)
    {
        Cookies.set('dnstop', event + "/" + new Date().getTime())
    };

    /**
     * Update the current number of unread chat replies to the given number. If you need to adjust the
     * existing number up or down, call dn.UnreadChatRepliesUpdate() instead.
     */
    dn.UnreadChatRepliesSet = function(numUnread)
    {
        $(".dn-unread-chat-replies").text(numUnread).attr("data-num-unread", numUnread); // .attr is used instead of .data because this value impacts styling, so DOM must be updated
    };

    /**
     * Update the current number of unread chat replies by the given amount. If you want to just
     * set the number of unread chat replies to a specific number, call dn.UnreadChatRepliesSet() instead.
     */
    dn.UnreadChatRepliesUpdate = function(amount)
    {
        // adjust the unread chat replies badges by subtracting the number of unread messages in this conversation
        var newUnread = parseInt($(".dn-unread-chat-replies").first().attr("data-num-unread")) + amount;

        if (isNaN(newUnread) || newUnread < 0)
        {
            // sanity check in case something goes ... very badly
            newUnread = 0;
        }

        dn.UnreadChatRepliesSet(newUnread);
    };

    // !!! IMPORTANT !!!
    // 
    // Called for every page load on DN. Make sure this stays as performant as possible.
    // 
    // !!! IMPORTANT !!!

    $(document).ready
    (
        function ($)
        {
            dn.ConvertTimestamps();

            window.addEventListener("message", dn.ReceiveMessage, false);

            $(window).on
            (
                "beforeunload", 
                function(event)
                {
                    // Disconnect any WebSockets we may have going
                    dn.realtime.Disconnect();

                    if (dn.compose.MessageEditsInProgress.length > 0) 
                    {
                        return "WARNING: If you leave now, any changes you made will be lost.";
                    }
                }
            );

            if (!Cookies.get('bc'))
            {
                Cookies.set('bc', '1', { expires: 30 });
                if (is.ie("<=10")) 
                {
                    dn.ShowModal
                    (
                        {
                            title: "Unsupported Browser", 
                            body: '<p class="lead">We noticed you\'re using a browser that we don\'t currently support.</p><p>Please be aware that some features may not work as expected.</p>We recommend modern browsers such as <a href="https://www.google.com/chrome/" target="' + dn.constants.LinkTargetNewWindow + '" rel="nofollow noopener">Chrome</a>, <a href="https://support.apple.com/downloads/safari" target="' + dn.constants.LinkTargetNewWindow + '" rel="nofollow noopener">Safari</a>, <a href="https://www.mozilla.org/firefox/" target="' + dn.constants.LinkTargetNewWindow + '" rel="nofollow noopener">Firefox</a> and <a href="https://www.microsoft.com/en-us/windows/microsoft-edge" target="' + dn.constants.LinkTargetNewWindow + '" rel="nofollow noopener">Edge</a>.<p></p>'
                        }
                    );
                }
            }

            // Setup our global AJAX handler that checks to make sure our code hasn't gone
            // berserk, making too many ajax requests in a short period of time. If it has,
            // the approveAjaxRequest function will abort the current ajax request, and then
            // overwrite the beforeSend code so that it immediately aborts any future requests.
            $.ajaxSetup({beforeSend: approveAjaxRequest});

            // Setup our global AJAX error handler so that it will call our HandleAjaxError function
            $(document).on('ajaxError', function(event, xhr, ajaxSettings, thrownError) { dn.HandleAjaxError(event, xhr, ajaxSettings, thrownError); });

            // Process any querystring
            if (window.location.search)
            {
                dn.QueryString = dn.QueryStringToJson(window.location.search);
            }

            // Wire up any invite links
            $('.dn-invite').click
            (
                function(e) 
                { 
                    e.preventDefault(); // Don't fire the /#action=invite link click
                    dn.user.Invite();
                }
            );

            // Process any #hash functionality
            if (window.location.hash)
            {
                dn.Hash = dn.QueryStringToJson(window.location.hash);

                if (dn.Hash.action === "post")
                {
                    // They want to start a post of a specific type, with a URL like this:
                    // 
                    // {Constants.BaseHref}/#action=post&type=9
                    // 
                    // Where type= specifies the TypeId of the post to start.
                    // 
                    // TODO: We'll probably want to use type streams to infer the type of the post, rather than type=N
                    setTimeout
                    (
                        function() 
                        {
                            dn.compose.StartPost(dn.Hash.type);
                            history.replaceState(null, document.title, window.location.href.substring(0, window.location.href.indexOf('#')));
                        }, 
                        100
                    );
                }
                else if (dn.Hash.action === "create" && dn.Hash.type === "group")
                {
                    // They want to create or update a user group
                    dn.topic.CreateOrUpdate();
                }
                else if (dn.Hash.action === "invite")
                {
                    dn.user.Invite();
                }
                else if (dn.Hash.action == "mute")
                {
                    if (dn.user.IsLoggedIn)
					{
                        /// ex: {Constants.BaseHref}/#action=mute&dk=m58mtkpernhkvg8oktlu0zj617&mk=m1o1pinx4glwp0opb8p5zxgwin
						
                        // Determine if we are muting a specific message or a full discussion
                        // If there is a discussion key present and we are not on that discussion's page
                        if (dn.Hash.dk && !(window.location.href.indexOf("/msg/") > 0) )
                        {
                            setTimeout
                            (
                                function() 
                                {
                                    window.location.replace(window.location.href.substring(0, window.location.href.indexOf('#')) 
                                        + "msg/" + dn.Hash.dk+"/#action=mute" + (dn.Hash.mk?'&mk=' + dn.Hash.mk:''))
                                }, 
                                100
                            );
                        } 

                        // If we are on msg page, we just want to kick off muting the target message
                        if (window.location.href.indexOf("/msg/") > 0)
                        {
                            dn.discussion.PromptMuteDiscussion(dn.Hash.mk);
                        }
                    }
                    else
                    {
                        window.top.location.href = "/account/login?returnurl=" + encodeURIComponent(window.location.href);
                    }
                }
            }

            // Show a permanent toast notification if the user has said they're a pro, but doesn't have the Pro badge yet.
            // if (dn.user.ShowProWarning)
            // {
            //     $("div.dn-partner").html
            //     (
            //         '<div class="card-body" style="color: #721c24; background-color: #f8d7da; border-color: #f5c6cb;"><p class="font-weight-bold">Earn the ' + dn.constants.BadgePro.Name + ' Badge (for Free)</p>' + 
            //         "<p>You indicated you are a professional working in the vehicle service industry. Now it's time to unlock all the pro discussions on " + dn.constants.CommunityName + " by earning the <a href=\"" + (dn.constants.BadgePro.UrlEarn || dn.constants.BadgePro.Link) + "\"><span class=\"badge\" data-badgekey=\"" + dn.constants.BadgePro.BadgeKey + "\" data-subscribe-target=\"topic\" style=\"" + dn.constants.BadgePro.Styles + "\">" + dn.constants.BadgePro.Name + '</span></a> badge, for free.</p><p><a href="' + (dn.constants.BadgePro.UrlEarn || dn.constants.BadgePro.Link) + '" role="button" class="btn btn-danger">' + (dn.constants.BadgePro.UrlEarn ? "Earn the " + dn.constants.BadgePro.Name + " Badge" : "Learn More") + "</button></p></div>"
            //     );
            // }

            $("#dn-search").on
            (
                "focus", 
                function()
                {
                    // When the user clicks into the search field, we want to expand the width of it to fill the screen,
                    // while simultaneously adding the class "dn-search-mode" to the <body> tag, which will hide the
                    // navigation elements (aside from the profile menu). This should push onto the history stack, so
                    // that the user can hit the back button to return to the previous state.
                    $("body").addClass("dn-search-mode");
                }
            );
    
            $("#dn-search").on
            (
                "blur", 
                function()
                {
                    // When the user clicks into the search field, we want to expand the width of it to fill the screen,
                    // while simultaneously adding the class "dn-search-mode" to the <body> tag, which will hide the
                    // navigation elements (aside from the profile menu). This should push onto the history stack, so
                    // that the user can hit the back button to return to the previous state.
    
                    if (!dn.search.IsSearching)
                    {
                        // Only deactivate "search mode" when leaving the search box if they aren't 
                        // actively performing some searches. 
                        $("body").removeClass("dn-search-mode");
                    }
                }
            );

            // Perform the search if someone presses ENTER key in the global search box
            // $("#dn-search").on
            // (
            //     'keydown',  // case insensitive, sees all keys (compared to keypress, case sensitive and ignores CTRL/SHIFT/ALT)
            //     function(e) 
            //     {
            //         if (e.which === 13) 
            //         {
            //             console.log('Search box')
            //             document.location = "/search?q=" + encodeURIComponent($("#dn-search").val());
            //             return false;
            //         }
            //     }
            // );

            $("#dn-search-form").on
            (
                'submit',  
                function(e) 
                {
                    console.log('Search form submitted', $("#dn-search").val());
                    window.location.href = "/search?q=" + encodeURIComponent($("#dn-search").val());
                    return false;
                }
            );

            $(window).keydown(function(e) 
            {
                if ((e.metaKey || e.ctrlKey) && e.shiftKey && e.keyCode === 70) // 70 is the keycode for 'F'
                {  
                    e.preventDefault();  // prevent the browser default action
                    
                    $("#dn-search").focus();

                    return false;
                }
            });
        }
    );

}(window.dn = window.dn || {}, jQuery));
